"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6271],{

/***/ 55041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16423);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27582);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}






const DEFAULT_SERVICELOGO = "/img/default_service_icon.svg";
const ItemWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    cursor: pointer;\n    width: 100%;\n\n    ".concat(theme.breakpoints.down("lg"), " {\n      flex-direction: column;\n      padding: 0px;\n      width: 100%;\n    }\n  ");
});
const ServiceClassificationIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (param)=>{
    let { theme , $hovered , src , type  } = param;
    return "\n    margin: 0 8px 0 0;\n    background: ".concat("url(".concat(src, ")"), " no-repeat;;\n    background-size: ").concat(type === "serviceClassification" ? "48px" : "100%", ";\n    background-position: 50% 50%;\n    min-width: 56px;\n    min-height: 56px;\n    border-radius: 28px;\n\n    ").concat(theme.breakpoints.down("lg"), " {\n      margin: 0 0 12px;\n    }\n  ");
});
const ItemTitle = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    font-weight: 400;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    font-size: 16px;\n    color: ".concat($hovered ? theme.palette.primary.main : theme.palette.text.minus1, ";\n    max-width: 100%;\n    word-break: break-word;\n    overflow-wrap: break-word;\n\n    ").concat(theme.breakpoints.down("lg"), " {\n      text-align: center;\n      max-width: 100%;\n    }\n  ");
});
const GridItemImage = (param)=>{
    let { item , menuDataForGa , subMenuDataForGa , subCatalogDataForGa , handleClose , onServiceClassificationClick , hasSubMenu  } = param;
    var _item_serviceClassification;
    const [hovered, setHovered] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    let iconSrc;
    if (item.type === "serviceClassification") {
        iconSrc = (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(item, "serviceClassification.entranceIcon.url", DEFAULT_SERVICELOGO);
    } else {
        iconSrc = (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(item, "icon.url", DEFAULT_SERVICELOGO);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ItemWrapper, {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        $hovered: hovered,
        onClick: ()=>{
            var _item_serviceClassification, _item_serviceClassification1;
            utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_6__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
                event: "living_action",
                living_event_name: "headermenu_click",
                living_click_name: (item === null || item === void 0 ? void 0 : item.type) === "serviceClassification" ? item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.name : item === null || item === void 0 ? void 0 : item.name,
                living_click_location: "web_主選單細項",
                ...(item === null || item === void 0 ? void 0 : (_item_serviceClassification1 = item.serviceClassification) === null || _item_serviceClassification1 === void 0 ? void 0 : _item_serviceClassification1._id) && {
                    living_click_id: item.serviceClassification._id
                },
                living_category1_name: menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa.name,
                ...(menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa._id) && {
                    living_category1_id: menuDataForGa._id
                },
                ...(subMenuDataForGa === null || subMenuDataForGa === void 0 ? void 0 : subMenuDataForGa.name) && hasSubMenu && {
                    living_category2_name: subMenuDataForGa.name
                },
                ...(subMenuDataForGa === null || subMenuDataForGa === void 0 ? void 0 : subMenuDataForGa._id) && hasSubMenu && {
                    living_category2_id: subMenuDataForGa._id
                },
                living_category3_name: subCatalogDataForGa === null || subCatalogDataForGa === void 0 ? void 0 : subCatalogDataForGa.name,
                ...(subCatalogDataForGa === null || subCatalogDataForGa === void 0 ? void 0 : subCatalogDataForGa._id) && {
                    living_category3_id: subCatalogDataForGa._id
                }
            });
            handleClose();
            onServiceClassificationClick(item);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ServiceClassificationIcon, {
                $hovered: hovered,
                src: iconSrc,
                type: item.type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemTitle, {
                    $hovered: hovered,
                    children: item.type === "serviceClassification" ? item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.name : item === null || item === void 0 ? void 0 : item.name
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GridItemImage);


/***/ }),

/***/ 66311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27582);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const ItemWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    padding: 8px 0;\n    cursor: pointer;\n\n    ".concat(theme.breakpoints.down("lg"), " {\n      flex-direction: column;\n    }\n  ");
});
const ItemTitle = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    font-weight: 400;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    font-size: 16px;\n    color: ".concat($hovered ? theme.palette.primary.main : theme.palette.text.minus1, ";\n  ");
});
const GridItemText = (param)=>{
    let { item , menuDataForGa , subMenuDataForGa , subCatalogDataForGa , handleClose , onServiceClassificationClick , hasSubMenu  } = param;
    var _item_serviceClassification;
    const [hovered, setHovered] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemWrapper, {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        $hovered: hovered,
        onClick: ()=>{
            var _item_serviceClassification, _item_serviceClassification1;
            utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_5__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
                event: "living_action",
                living_event_name: "headermenu_click",
                living_click_name: (item === null || item === void 0 ? void 0 : item.type) === "serviceClassification" ? item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.name : item === null || item === void 0 ? void 0 : item.name,
                living_click_location: "web_主選單細項",
                ...(item === null || item === void 0 ? void 0 : (_item_serviceClassification1 = item.serviceClassification) === null || _item_serviceClassification1 === void 0 ? void 0 : _item_serviceClassification1._id) && {
                    living_click_id: item.serviceClassification._id
                },
                living_category1_name: menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa.name,
                ...(menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa._id) && {
                    living_category1_id: menuDataForGa._id
                },
                ...(subMenuDataForGa === null || subMenuDataForGa === void 0 ? void 0 : subMenuDataForGa.name) && hasSubMenu && {
                    living_category2_name: subMenuDataForGa.name
                },
                ...(subMenuDataForGa === null || subMenuDataForGa === void 0 ? void 0 : subMenuDataForGa._id) && hasSubMenu && {
                    living_category2_id: subMenuDataForGa._id
                },
                living_category3_name: subCatalogDataForGa === null || subCatalogDataForGa === void 0 ? void 0 : subCatalogDataForGa.name,
                ...(subCatalogDataForGa === null || subCatalogDataForGa === void 0 ? void 0 : subCatalogDataForGa._id) && {
                    living_category3_id: subCatalogDataForGa._id
                }
            });
            handleClose();
            onServiceClassificationClick(item);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemTitle, {
                $hovered: hovered,
                children: item.type === "serviceClassification" ? item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.name : item === null || item === void 0 ? void 0 : item.name
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GridItemText);


/***/ }),

/***/ 36271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_NavButtonList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./config/theme.js + 1 modules
var config_theme = __webpack_require__(26059);
// EXTERNAL MODULE: ./components/common/GridItem/GridItemText.js
var GridItemText = __webpack_require__(66311);
// EXTERNAL MODULE: ./components/common/SVGElements/ArrowRight.js
var ArrowRight = __webpack_require__(69854);
// EXTERNAL MODULE: ./store/pageLoad/pageLoadSlice.js
var pageLoadSlice = __webpack_require__(21095);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./components/common/GridItemWrapper/Desktop/NavGridText.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 24px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}










const GridWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject());
const Link = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    font-weight: bold;\n    background: ".concat(theme.palette.grey.third, ";\n    padding: 12px 12px 12px 20px;\n    cursor: pointer;\n    border-radius: 6px;\n    &:hover {\n      background: ").concat(theme.palette.primary.bgPlus1, ";\n    }\n  ");
});
const NavGridText = (param)=>{
    let { content , menuDataForGa , hasSubMenu , onLinkClick , onCatalogOrSubMenuClick , onServiceClassificationClick  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showSubcatalog, setShowSubcatalog] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const list = content === null || content === void 0 ? void 0 : content.subcatalogs;
        setShowSubcatalog(list === null || list === void 0 ? void 0 : list.sort((a, b)=>{
            if (b.sort !== a.sort) {
                return b.sort - a.sort;
            }
            return new Date(b.createdAt) - new Date(a.createdAt);
        }).filter((listItem)=>{
            return (listItem === null || listItem === void 0 ? void 0 : listItem.items.length) > 0;
        }));
    }, [
        content.name,
        hasSubMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            (content === null || content === void 0 ? void 0 : content.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 8,
                display: "flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                    display: "inline-flex",
                    alignItems: "center",
                    onClick: ()=>{
                        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                            event: "living_action",
                            living_event_name: "headermenu_click",
                            living_click_name: (content === null || content === void 0 ? void 0 : content.linkDisplayName) ? content.linkDisplayName : "前往".concat(content === null || content === void 0 ? void 0 : content.name),
                            living_click_location: "web_主選單細項",
                            living_category1_name: menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa.name,
                            ...(menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa._id) && {
                                living_category1_id: menuDataForGa._id
                            },
                            ...(content === null || content === void 0 ? void 0 : content.name) && hasSubMenu && {
                                living_category2_name: content.name
                            },
                            ...(content === null || content === void 0 ? void 0 : content._id) && hasSubMenu && {
                                living_category2_id: content._id
                            }
                        });
                        dispatch((0,pageLoadSlice/* setNavbarClicked */.cW)(true));
                        onCatalogOrSubMenuClick(content);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "inline-block",
                            color: "primary.main",
                            marginRight: 1,
                            children: content.linkDisplayName ? content.linkDisplayName : "前往".concat(content.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                            color: "text.secondary"
                        })
                    ]
                })
            }) : "",
            hasSubMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "labelLarge",
                color: "text.secondary",
                sx: {
                    pb: 4
                },
                children: content.name
            }),
            showSubcatalog.map((listItem, index)=>{
                var _listItem_items;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: index === 0 ? 0 : 6,
                    children: [
                        (showSubcatalog === null || showSubcatalog === void 0 ? void 0 : showSubcatalog.length) > 1 || hasSubMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "labelLarge",
                            color: hasSubMenu ? "text.disabled" : "text.secondary",
                            children: listItem.name
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 2.5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper, {
                                children: listItem === null || listItem === void 0 ? void 0 : (_listItem_items = listItem.items) === null || _listItem_items === void 0 ? void 0 : _listItem_items.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItemText/* default */.Z, {
                                        item: item,
                                        menuDataForGa: menuDataForGa,
                                        subMenuDataForGa: {
                                            name: content.name,
                                            _id: content === null || content === void 0 ? void 0 : content._id
                                        },
                                        subCatalogDataForGa: {
                                            name: listItem.name,
                                            _id: listItem === null || listItem === void 0 ? void 0 : listItem._id
                                        },
                                        handleClose: onLinkClick,
                                        onServiceClassificationClick: onServiceClassificationClick,
                                        hasSubMenu: hasSubMenu
                                    }, index);
                                })
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var Desktop_NavGridText = (NavGridText);

// EXTERNAL MODULE: ./components/common/GridItem/GridItemImage.js
var GridItemImage = __webpack_require__(55041);
;// CONCATENATED MODULE: ./components/common/GridItemWrapper/Desktop/NavGridImage.js

function NavGridImage_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: 8px 16px;\n"
    ]);
    NavGridImage_templateObject = function() {
        return data;
    };
    return data;
}
function NavGridImage_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavGridImage_templateObject1 = function() {
        return data;
    };
    return data;
}










const NavGridImage_GridWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavGridImage_templateObject(), (param)=>{
    let { hasSubMenu  } = param;
    return hasSubMenu ? "1fr 1fr 1fr" : "1fr 1fr 1fr 1fr";
});
const NavGridImage_Link = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavGridImage_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    font-weight: bold;\n    background: ".concat(theme.palette.grey.third, ";\n    padding: 12px 12px 12px 20px;\n    cursor: pointer;\n    border-radius: 6px;\n    &:hover {\n      background: ").concat(theme.palette.primary.bgPlus1, ";\n    }\n  ");
});
const NavGridImage = (param)=>{
    let { content , menuDataForGa , hasSubMenu , onLinkClick , onCatalogOrSubMenuClick , onServiceClassificationClick  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showSubcatalog, setShowSubcatalog] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const list = content === null || content === void 0 ? void 0 : content.subcatalogs;
        setShowSubcatalog(list === null || list === void 0 ? void 0 : list.sort((a, b)=>{
            if (b.sort !== a.sort) {
                return b.sort - a.sort;
            }
            return new Date(b.createdAt) - new Date(a.createdAt);
        }).filter((listItem)=>{
            return (listItem === null || listItem === void 0 ? void 0 : listItem.items.length) > 0;
        }));
    }, [
        content.name,
        hasSubMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            hasSubMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "labelLarge",
                color: "text.secondary",
                sx: {
                    pb: 4
                },
                children: content.name
            }),
            showSubcatalog.map((listItem, index)=>{
                var _listItem_items;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: index === 0 ? 0 : 6,
                    children: [
                        (showSubcatalog === null || showSubcatalog === void 0 ? void 0 : showSubcatalog.length) > 1 || hasSubMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "labelLarge",
                            color: hasSubMenu ? "text.disabled" : "text.secondary",
                            children: listItem.name
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 2.5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavGridImage_GridWrapper, {
                                hasSubMenu: !!hasSubMenu,
                                children: listItem === null || listItem === void 0 ? void 0 : (_listItem_items = listItem.items) === null || _listItem_items === void 0 ? void 0 : _listItem_items.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItemImage/* default */.Z, {
                                        item: item,
                                        menuDataForGa: menuDataForGa,
                                        subMenuDataForGa: {
                                            name: content === null || content === void 0 ? void 0 : content.name,
                                            _id: content === null || content === void 0 ? void 0 : content._id
                                        },
                                        subCatalogDataForGa: {
                                            name: listItem === null || listItem === void 0 ? void 0 : listItem.name,
                                            _id: listItem === null || listItem === void 0 ? void 0 : listItem._id
                                        },
                                        handleClose: onLinkClick,
                                        onServiceClassificationClick: onServiceClassificationClick,
                                        hasSubMenu: hasSubMenu
                                    }, index);
                                })
                            })
                        })
                    ]
                }, index);
            }),
            (content === null || content === void 0 ? void 0 : content.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 8,
                display: "flex",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavGridImage_Link, {
                    display: "inline-flex",
                    alignItems: "center",
                    onClick: ()=>{
                        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                            event: "living_action",
                            living_event_name: "headermenu_click",
                            living_click_name: (content === null || content === void 0 ? void 0 : content.linkDisplayName) ? content.linkDisplayName : "前往".concat(content === null || content === void 0 ? void 0 : content.name),
                            living_click_location: "web_主選單細項",
                            living_category1_name: menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa.name,
                            ...(menuDataForGa === null || menuDataForGa === void 0 ? void 0 : menuDataForGa._id) && {
                                living_category1_id: menuDataForGa._id
                            },
                            ...(content === null || content === void 0 ? void 0 : content.name) && hasSubMenu && {
                                living_category2_name: content.name
                            },
                            ...(content === null || content === void 0 ? void 0 : content._id) && hasSubMenu && {
                                living_category2_id: content._id
                            }
                        });
                        dispatch((0,pageLoadSlice/* setNavbarClicked */.cW)(true));
                        onCatalogOrSubMenuClick(content);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "inline-block",
                            color: "primary.main",
                            children: content.linkDisplayName ? content.linkDisplayName : "前往".concat(content.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                            color: "text.secondary"
                        })
                    ]
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var Desktop_NavGridImage = (NavGridImage);

;// CONCATENATED MODULE: ./components/common/Header/NavPanelWithTab.js

function NavPanelWithTab_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavPanelWithTab_templateObject = function() {
        return data;
    };
    return data;
}
function NavPanelWithTab_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavPanelWithTab_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}







const NavPanel = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavPanelWithTab_templateObject(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: ".concat(config_theme/* headerHeight */.J9, ";\n    max-width: ").concat(config_theme/* indexPageMaxContentWidth */.LN, ";\n    margin: 0 36px;\n    height: calc(100vw * 0.35);\n    background-color: rgba(251, 251, 251);\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 24px;\n    z-index: 50;\n    opacity: ").concat($hovered ? 1 : 0, ";\n    transition: all .2s linear;\n    pointer-events: ").concat($hovered ? "default" : "none", ";\n    display: flex;\n    padding: 24px 16px;\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      margin: 0 auto;\n    }\n  ");
});
const LeftPanel = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavPanelWithTab_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    width: 32%;\n    flex-shrink: 0;\n    overflow-y: auto;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: 270px;\n    }\n  ");
});
const RightPanel = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    flex-grow: 1;\n    border-left: 1px solid ".concat(theme.palette.grey.secondary, ";\n    overflow-y: auto;\n  ");
});
// 用物件樣式而非樣板字串的寫法是因為要使用不同字體
const SubMenuTab = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)((param)=>{
    let { theme , $isActive  } = param;
    return {
        minHeight: "48px",
        display: "flex",
        alignItems: "center",
        padding: "12px 24px",
        cursor: "pointer",
        borderRadius: "6px",
        backgroundColor: $isActive ? theme.palette.grey.third : "transparent",
        ...$isActive ? theme.typography.paraTitleSmall : theme.typography.paraBodyMedium,
        "&:hover": {
            backgroundColor: theme.palette.grey.third,
            ...theme.typography.paraTitleSmall
        },
        lineHeight: "140%"
    };
});
const NavPanelWithTab = (param)=>{
    let { navContent , hasSubMenu , onLinkClick , onCatalogOrSubMenuClick , onServiceClassificationClick , isTextMode , $hovered  } = param;
    const subMenus = navContent === null || navContent === void 0 ? void 0 : navContent.subMenus;
    if (Array.isArray(subMenus)) {
        subMenus.sort((a, b)=>{
            if (b.sort !== a.sort) {
                return b.sort - a.sort;
            }
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
    }
    const [activeSubMenuIndex, setActiveSubMenuIndex] = (0,react.useState)(0);
    const activeSubMenu = subMenus[activeSubMenuIndex];
    const subMenuTabRefs = (0,react.useRef)([]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavPanel, {
        $hovered: $hovered,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPanel, {
                children: subMenus.map((subMenu, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenuTab, {
                        ref: (el)=>subMenuTabRefs.current[index] = el,
                        $isActive: activeSubMenuIndex === index,
                        onMouseEnter: ()=>setActiveSubMenuIndex(index),
                        children: subMenu.name
                    }, subMenu.name))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 12,
                    px: 9,
                    children: isTextMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_NavGridText, {
                        content: activeSubMenu,
                        menuDataForGa: {
                            name: navContent.name,
                            _id: navContent === null || navContent === void 0 ? void 0 : navContent._id
                        },
                        hasSubMenu: hasSubMenu,
                        onLinkClick: onLinkClick,
                        onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                        onServiceClassificationClick: onServiceClassificationClick
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_NavGridImage, {
                        content: activeSubMenu,
                        menuDataForGa: {
                            name: navContent.name,
                            _id: navContent === null || navContent === void 0 ? void 0 : navContent._id
                        },
                        hasSubMenu: hasSubMenu,
                        onLinkClick: onLinkClick,
                        onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                        onServiceClassificationClick: onServiceClassificationClick
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Header_NavPanelWithTab = (NavPanelWithTab);

;// CONCATENATED MODULE: ./components/common/Header/NavButton.js

function NavButton_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavButton_templateObject = function() {
        return data;
    };
    return data;
}
function NavButton_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavButton_templateObject1 = function() {
        return data;
    };
    return data;
}
function NavButton_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    NavButton_templateObject2 = function() {
        return data;
    };
    return data;
}











const InnerBox = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavButton_templateObject(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    cursor: pointer;\n    text-align: center;\n\n    &::after {\n      content: '';\n      width: 32px;\n      height: 4px;\n      display: block;\n      visibility: ".concat($hovered ? "visible" : "hidden", ";\n      background: ").concat(theme.palette.primary.main, ";\n      margin: auto;\n      border-radius: 10px;\n      position: relative;\n      top: 2px;\n    }\n  ");
});
const NavButton_NavPanel = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(NavButton_templateObject1(), (param)=>{
    let { theme , $hovered  } = param;
    return "\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: ".concat(config_theme/* headerHeight */.J9, ";\n    max-width: ").concat(config_theme/* indexPageMaxContentWidth */.LN, ";\n    margin: 0 36px;\n    height: auto;\n    max-height: calc(100vw * 0.35);\n    overflow-y: auto;\n    background-color: rgba(251, 251, 251);\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 24px;\n    z-index: 50;\n    opacity: ").concat($hovered ? 1 : 0, ";\n    transition: all .2s linear;\n    pointer-events: ").concat($hovered ? "default" : "none", ";\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      margin: 0 auto;\n    }\n  ");
});
const NavButton = (param)=>{
    let { children , navContent , className , onCatalogOrSubMenuClick , onServiceClassificationClick , ...rest } = param;
    var _navContent_subMenus;
    const [hovered, setHovered] = (0,react.useState)(false);
    const navbarClicked = (0,es/* useSelector */.v9)(pageLoadSlice/* selectNavbarClicked */.xg);
    const isNavPanelWithTab = (navContent === null || navContent === void 0 ? void 0 : (_navContent_subMenus = navContent.subMenus) === null || _navContent_subMenus === void 0 ? void 0 : _navContent_subMenus.length) > 0;
    const isTextMode = (navContent === null || navContent === void 0 ? void 0 : navContent.displayMode) === "text";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "body2",
        className: className,
        mx: 1.5,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                fontWeight: "fontWeightBold",
                height: config_theme/* headerHeight */.J9,
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerBox, {
                    px: 2,
                    pb: 1,
                    pt: 2,
                    $hovered: hovered,
                    children: children
                })
            }),
            !!navContent && (isNavPanelWithTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavPanelWithTab, {
                $hovered: hovered && !navbarClicked,
                navContent: navContent,
                hasSubMenu: isNavPanelWithTab,
                onLinkClick: ()=>setHovered(false),
                onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                onServiceClassificationClick: onServiceClassificationClick,
                isTextMode: isTextMode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButton_NavPanel, {
                $hovered: hovered && !navbarClicked,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 12,
                    mt: 9,
                    px: 9,
                    children: isTextMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_NavGridText, {
                        content: navContent,
                        menuDataForGa: {
                            name: navContent.name,
                            _id: navContent === null || navContent === void 0 ? void 0 : navContent._id
                        },
                        hasSubMenu: isNavPanelWithTab,
                        onLinkClick: ()=>setHovered(false),
                        onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                        onServiceClassificationClick: onServiceClassificationClick
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_NavGridImage, {
                        content: navContent,
                        menuDataForGa: {
                            name: navContent.name,
                            _id: navContent === null || navContent === void 0 ? void 0 : navContent._id
                        },
                        hasSubMenu: isNavPanelWithTab,
                        onLinkClick: ()=>setHovered(false),
                        onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                        onServiceClassificationClick: onServiceClassificationClick
                    })
                })
            }))
        ]
    });
};
const StyledNavButton = (0,emotion_styled_browser_esm/* default */.Z)(NavButton)(NavButton_templateObject2());
/* harmony default export */ var Header_NavButton = (StyledNavButton);

// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(36409);
;// CONCATENATED MODULE: ./components/common/Header/NavButtonList.js









const NavButtonList = (param)=>{
    let { catalogs , onCatalogOrSubMenuClick , onServiceClassificationClick  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const navbarClicked = (0,es/* useSelector */.v9)(pageLoadSlice/* selectNavbarClicked */.xg);
    (0,react.useEffect)(()=>{
        const mousemoveEvent = (0,debounce/* default */.Z)(()=>{
            if (navbarClicked) dispatch((0,pageLoadSlice/* setNavbarClicked */.cW)(false));
        }, 100);
        window.addEventListener("mousemove", mousemoveEvent);
        return ()=>{
            window.removeEventListener("mousemove", mousemoveEvent);
        };
    }, [
        navbarClicked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* HideInMobileBox */.dz, {
        display: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: 4.5
            }),
            catalogs === null || catalogs === void 0 ? void 0 : catalogs.map((catalog, index)=>{
                var _catalog_subcatalogs, _catalog_subMenus;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavButton, {
                    navbarClicked: navbarClicked,
                    navContent: (catalog === null || catalog === void 0 ? void 0 : (_catalog_subcatalogs = catalog.subcatalogs) === null || _catalog_subcatalogs === void 0 ? void 0 : _catalog_subcatalogs.some((subcatalog)=>{
                        return (subcatalog === null || subcatalog === void 0 ? void 0 : subcatalog.items.length) > 0;
                    })) || (catalog === null || catalog === void 0 ? void 0 : (_catalog_subMenus = catalog.subMenus) === null || _catalog_subMenus === void 0 ? void 0 : _catalog_subMenus.some((subMenu)=>{
                        var _subMenu_subcatalogs;
                        return (subMenu === null || subMenu === void 0 ? void 0 : (_subMenu_subcatalogs = subMenu.subcatalogs) === null || _subMenu_subcatalogs === void 0 ? void 0 : _subMenu_subcatalogs.length) > 0;
                    })) ? catalog : "",
                    onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                    onServiceClassificationClick: onServiceClassificationClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>{
                            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                                event: "living_action",
                                living_event_name: "headermenu_click",
                                living_click_name: catalog === null || catalog === void 0 ? void 0 : catalog.name,
                                living_click_location: "web_主選單",
                                ...(catalog === null || catalog === void 0 ? void 0 : catalog._id) && {
                                    living_click_id: catalog._id
                                }
                            });
                            if (catalog.link && catalog.menuType !== "mainWithSub") {
                                dispatch((0,pageLoadSlice/* setNavbarClicked */.cW)(true));
                                onCatalogOrSubMenuClick(catalog);
                            }
                        },
                        children: catalog.name
                    })
                }, "catalog-" + index);
            })
        ]
    });
};
/* harmony default export */ var Header_NavButtonList = (NavButtonList);


/***/ }),

/***/ 18450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ HideInDesktopGrid; },
/* harmony export */   "W": function() { return /* binding */ HideInMobileGrid; },
/* harmony export */   "aI": function() { return /* binding */ HideInDesktopBox; },
/* harmony export */   "dz": function() { return /* binding */ HideInMobileBox; }
/* harmony export */ });
/* unused harmony exports withHideInMobile, withHideInDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79072);



const withHideInMobile = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: "none",
                    lg: finalDisplay
                },
                ...sx
            },
            ...props
        });
    };
};
const withHideInDesktop = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: finalDisplay,
                    lg: "none"
                },
                ...sx
            },
            ...props
        });
    };
};
const HideInMobileBox = withHideInMobile(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInDesktopBox = withHideInDesktop(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInMobileGrid = withHideInMobile(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
const HideInDesktopGrid = withHideInDesktop(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);


/***/ }),

/***/ 69854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowRight = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        $color: color,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_right_24l",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 54806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16423);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46338);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const SVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg */ .Z.svg(_templateObject(), (param)=>{
    let { theme , primary , error , white , textSecondary , $ptr , $color  } = param;
    return "\n    fill: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
        [
            (props)=>props.error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.primary,
            ()=>theme.palette.primary.main
        ],
        [
            (props)=>props.white,
            ()=>theme.palette.primary.contrastText
        ],
        [
            (props)=>props.textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            ()=>theme.palette.text.primary
        ]
    ])({
        primary,
        error,
        white,
        textSecondary,
        $color
    }), ";\n    ").concat($ptr ? "cursor: pointer;" : "", "\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (SVG);


/***/ }),

/***/ 21095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ setSelfConstructParamsInitialized; },
/* harmony export */   "De": function() { return /* binding */ setEncryptedUserIdReady; },
/* harmony export */   "KQ": function() { return /* binding */ selectPageLoad; },
/* harmony export */   "PA": function() { return /* binding */ setEncryptedPhone; },
/* harmony export */   "b7": function() { return /* binding */ setEncryptedPhoneReady; },
/* harmony export */   "cW": function() { return /* binding */ setNavbarClicked; },
/* harmony export */   "gG": function() { return /* binding */ setPageLoadAuthReadyInitialized; },
/* harmony export */   "gt": function() { return /* binding */ setEncryptedUserId; },
/* harmony export */   "pG": function() { return /* binding */ selectEnctyptedUserId; },
/* harmony export */   "xg": function() { return /* binding */ selectNavbarClicked; }
/* harmony export */ });
/* unused harmony export pageLoadSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const pageLoadSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "pageLoad",
    initialState: {
        // 紀錄進入網站第一個頁面的初始化是否已執行，
        // 該初始化只會在使用者資料準備好後執行
        authReadyInitialized: false,
        // 儲存加密後的user id，用於傳送firebase event
        encryptedUserId: {
            value: "",
            isReady: false
        },
        // 儲存加密後的手機號碼，用於防止重複呼叫加密API
        encryptedPhone: {
            value: "",
            isReady: false
        },
        // 自建單參數設定
        selfConstructParamsInitialized: false,
        // 判斷navbar點擊狀態
        navbarClicked: false
    },
    reducers: {
        setPageLoadAuthReadyInitialized: (state, action)=>{
            state.authReadyInitialized = action.payload;
        },
        setEncryptedUserId: (state, action)=>{
            state.encryptedUserId.value = action.payload;
            state.encryptedUserId.isReady = true;
        },
        setEncryptedUserIdReady: (state, action)=>{
            state.encryptedUserId.isReady = action.payload;
        },
        setEncryptedPhone: (state, action)=>{
            state.encryptedPhone.value = action.payload;
            state.encryptedPhone.isReady = true;
        },
        setEncryptedPhoneReady: (state, action)=>{
            state.encryptedPhone.isReady = action.payload;
        },
        setSelfConstructParamsInitialized: (state, action)=>{
            state.selfConstructParamsInitialized = action.payload;
        },
        setNavbarClicked: (state, action)=>{
            state.navbarClicked = action.payload;
        }
    }
});
const selectPageLoad = (state)=>state.pageLoad;
const selectEnctyptedUserId = (state)=>state.pageLoad.encryptedUserId;
const selectNavbarClicked = (state)=>state.pageLoad.navbarClicked;
const { setPageLoadAuthReadyInitialized , setEncryptedUserId , setEncryptedUserIdReady , setEncryptedPhone , setEncryptedPhoneReady , setSelfConstructParamsInitialized , setNavbarClicked  } = pageLoadSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (pageLoadSlice.reducer);


/***/ }),

/***/ 18069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["Z"] = (apply);


/***/ }),

/***/ 77762:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _baseRest; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/identity.js
var identity = __webpack_require__(69203);
// EXTERNAL MODULE: ./node_modules/lodash-es/_apply.js
var _apply = __webpack_require__(18069);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return (0,_apply/* default */.Z)(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

// EXTERNAL MODULE: ./node_modules/lodash-es/_defineProperty.js
var _defineProperty = __webpack_require__(77904);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty/* default */.Z ? identity/* default */.Z : function(func, string) {
  return (0,_defineProperty/* default */.Z)(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity/* default */.Z), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);


/***/ }),

/***/ 93021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _apply_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18069);
/* harmony import */ var _arrayMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74073);
/* harmony import */ var _baseIteratee_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32703);
/* harmony import */ var _baseRest_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77762);





/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = _baseIteratee_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;

  pairs = !length ? [] : (0,_arrayMap_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return (0,_baseRest_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if ((0,_apply_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(pair[0], this, args)) {
        return (0,_apply_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(pair[1], this, args);
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (cond);


/***/ }),

/***/ 36409:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_debounce; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(77226);
// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__(66092);
;// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root/* default.Date.now */.Z.Date.now();
};

/* harmony default export */ var lodash_es_now = (now);

// EXTERNAL MODULE: ./node_modules/lodash-es/toNumber.js + 2 modules
var toNumber = __webpack_require__(21357);
;// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = (0,toNumber/* default */.Z)(wait) || 0;
  if ((0,isObject/* default */.Z)(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax((0,toNumber/* default */.Z)(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce);


/***/ }),

/***/ 46338:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/* harmony default export */ __webpack_exports__["Z"] = (stubTrue);


/***/ })

}]);